import styles from "../styles/ui/ActionButtonsWrapper.module.css";

function ActionButtonsWrapper({ className = "", style = {}, children }) {
  return (
    <ul className={`${styles.container} ${className}`} style={style}>
      {children}
    </ul>
  );
}

export default ActionButtonsWrapper;
